import { Menu } from '@services/api/menus'

import chunk from 'lodash.chunk'
import Link from 'next/link'
import cl from 'classnames'

interface Props {
  menus: Menu[]
  className?: string
}

export const MenuContentWithSubItems = ({ menus, className }: Props) => {
  return (
    <div className={cl('flex gap-x-10', className)}>
      {chunk(menus, 6)?.map((menuChunk, index) => {
        return (
          <div key={index} className={cl('flex flex-col gap-x-10 gap-y-2')}>
            {menuChunk.map(menu => {
              return menu.url ? (
                <Link
                  key={`menu-children-sub-item-${menu.id}`}
                  href={menu.url}
                  className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
                  {...(menu.newTab && {
                    target: '_blank',
                    rel: 'noreferrer'
                  })}
                >
                  {menu.description}
                </Link>
              ) : (
                <span
                  key={`menu-children-sub-item-${menu.id}`}
                  className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
                >
                  {menu.description}
                </span>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
